import React from "react";
import { CircularProgress, Tooltip } from "@material-ui/core";

export default function AutoRefreshRing({
  seconds = 5,
  size = 22,
  thickness = 4,
  isLoading = false,
  onTickComplete,
  tooltip = "Auto-refresh cada 5 segundos",
}) {
  const totalMs = Math.max(1, seconds * 1000);
  const stepMs = 100; // constante
  const [progress, setProgress] = React.useState(0);

  // Guardar callback en ref para que el interval NO dependa de su identidad
  const onTickCompleteRef = React.useRef(onTickComplete);
  React.useEffect(() => {
    onTickCompleteRef.current = onTickComplete;
  }, [onTickComplete]);

  // Lock anti-doble-disparo
  const tickLockRef = React.useRef(false);

  React.useEffect(() => {
    let elapsed = 0;

    const id = setInterval(() => {
      // Si está cargando, no avanzar el anillo (queda "congelado")
      if (isLoading) return;

      elapsed += stepMs;
      const next = Math.min(100, (elapsed / totalMs) * 100);
      setProgress(next);

      if (next >= 100) {
        // Evitar doble tick por re-renders / recreación de interval
        if (tickLockRef.current) return;
        tickLockRef.current = true;

        elapsed = 0;
        setProgress(0);

        try {
          if (typeof onTickCompleteRef.current === "function") {
            onTickCompleteRef.current();
          }
        } finally {
          // liberar lock luego de un pequeño delay
          // (permite que el padre setee isLoading y evita dobles disparos)
          setTimeout(() => {
            tickLockRef.current = false;
          }, 250);
        }
      }
    }, stepMs);

    return () => clearInterval(id);
  }, [totalMs, isLoading]); // ✅ sin onTickComplete, sin stepMs

  return (
    <Tooltip title={tooltip}>
      <span style={{ display: "inline-flex", alignItems: "center" }}>
        <CircularProgress
          variant="determinate"
          value={progress}
          size={size}
          thickness={thickness}
        />
      </span>
    </Tooltip>
  );
}
